import React, { useEffect, useState } from 'react';
import { getLocalStorageItem } from '../../utils/safeStorage';
import { API_BASE_URL } from '../../services/apiRegistry';

function isPublicHttpUrl(u) {
  if (u == null || typeof u !== 'string') return false;
  return /^https?:\/\//i.test(u.trim());
}

/**
 * Coach headshot per CRS + HPS handoff (`docs/coaches v 01.md`):
 * 1) If `photoUrl` is an absolute http(s) URL, use it.
 * 2) Else if `hasPhotoImage`, load bytes via GET /api/crs/coaches/:coachId/photo (player JWT).
 * 3) Else placeholder.
 */
export default function CoachAvatarImage({ coachId, photoUrl, hasPhotoImage = false, alt = '', className, style }) {
  const [src, setSrc] = useState(() => (isPublicHttpUrl(photoUrl) ? photoUrl.trim() : null));

  useEffect(() => {
    if (isPublicHttpUrl(photoUrl)) {
      setSrc(photoUrl.trim());
      return () => {};
    }

    let revoked = false;
    let objectUrl = null;

    const token = getLocalStorageItem('token');
    if (!coachId || !token || !hasPhotoImage) {
      setSrc(null);
      return () => {};
    }

    fetch(`${API_BASE_URL}/crs/coaches/${coachId}/photo`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.blob() : null))
      .then((blob) => {
        if (revoked || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!revoked) setSrc(null);
      });

    return () => {
      revoked = true;
      if (objectUrl && objectUrl.startsWith('blob:')) URL.revokeObjectURL(objectUrl);
    };
  }, [coachId, photoUrl, hasPhotoImage]);

  if (!src) {
    return <div className={className} style={{ ...style, background: '#e2e8f0' }} aria-hidden />;
  }

  return <img src={src} alt={alt} className={className} style={style} />;
}
